<!-- 节目集查看详情弹窗 -->
<template>
  <div>
    <el-dialog
      width="960px"
      title="查看详情"
      :visible.sync="dialogFormVisible"
      showClose
      append-to-body
      center
      v-if="dialogFormVisible"
    >
      <div class="dialog-info-box">
        <video-info :imgUrl="imgUrl" :isProgram="isProgram" :videoPath="videoPath" ref="videoPlay"/>
        <item-info v-if="insideData" :insideData="insideData" :goEdit='goEdit' :isProgram="isProgram" @goEditPage="goEditPage"/>
        <file-info v-if="groupIn=='program'" :insideData="insideData" />
        <state-info v-if="(groupIn=='programs')&&(project == 'VOD')"  :insideData="insideData" @goRelease="goRelease" />
      </div>
    </el-dialog>
  </div>

</template>
<script>
import VideoInfo from '@/components/Video'
import FileInfo from '@/components/FileInfo'
import ItemInfo from '@/components/ItemInfo'
import StateInfo from '@/components/StateInfo'
export default {
  props: ['insideData', 'groupIn', 'goEdit', 'imgUrl'],
  components: {
    ItemInfo,
    VideoInfo,
    FileInfo,
    StateInfo
  },
  data () {
    return {
      releaseData: [],
      dialogFormVisible: false,
      isProgram: 'programs',
      project: process.env.VUE_APP_NODE_ENV,
      videoPath: ''
    }
  },
  methods: {
    open () {
      if (this.groupIn == 'program') {
        this.isProgram = 'program'
        this.videoPath = this.insideData.video && this.insideData.video.videoPath
        this.insideData.isPublish = this.insideData.pushFlag != -1
      } else {
        this.insideData.isPublish = this.insideData.pushState != 0
      }
      this.dialogFormVisible = true
    },
    goRelease () {
      this.$emit('goRelease', this.insideData.id)
    },
    goEditPage () {
      this.$emit('goEditPage', this.insideData)
    }
  }
}
</script>
